<form [formGroup]="form" class="form-group margin-bottom-0">
  <div class="form-row" *ngIf="!tempPassword && !resetInd && askCurrentPassword">
    <townip-input class="col-12">
      <label>Current Password</label>
      <input type="password" class="form-control" formControlName="currentPassword">
    </townip-input>
  </div>
  <div class="form-row">
    <townip-input-password class="col-12">
      <label>New Password</label>
      <input type="password" class="form-control" formControlName="password">
    </townip-input-password>
  </div>
  <div class="form-row">
    <townip-input class="col-12">
      <label>Confirm New Password</label>
      <input type="password" class="form-control" (blur)="checkPasswordsMatch()" formControlName="confirmPassword">
    </townip-input>
  </div>
  <div class="form-row margin-top-20 margin-bottom-30" *ngIf="showError">
    <div class="col-12">
      <div class="alert alert-danger margin-bottom-0">
        The passwords do not match
      </div>
    </div>
  </div>
</form>
